// extracted by mini-css-extract-plugin
export default {"cls1":"fjhRR2tBbehQD5ddC7Bj","cls2":"AX3JCou27tZhXcNNnhhc fjhRR2tBbehQD5ddC7Bj"};